// extracted by mini-css-extract-plugin
module.exports = {"root":"root-1gvt2nUbdR","blank":"blank-352fzSuvnb"};